import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import CourseList from './Main'

// const populates = [{ child: 'provider', root: 'providers' }]

export default compose(
  firebaseConnect(props => {
    return ['courses', 'providers']
  }),
  connect(state => ({
    courses: state.firebase.data.courses || {},
    providers: state.firebase.data.providers || {}
  }))
)(withRouter(CourseList))



// WEBPACK FOOTER //
// ./src/views/CourseList/index.js